import script from "./OperadorDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./OperadorDashboard.vue?vue&type=script&setup=true&lang=js"

import "./OperadorDashboard.vue?vue&type=style&index=0&id=f5440798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5440798"]])

export default __exports__